import {
  WHISLIST,
} from "../Type/type";

export const openWhislist = (isOpen) => {
  return {
    type: WHISLIST,
    payload: isOpen,
  };
};

